import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProfilePage from "./pages/ProfilePage";
import AccountSettingsPage from "./pages/AccountSettingsPage";
import EmailChangeVerificationPage from "./pages/EmailChangeVerificationPage";
import DashboardPage from "./pages/DashboardPage";
import FundTracker from "./pages/FundTracker";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./pages/LandingPage";
import AboutPage from "./pages/AboutPage";
import LoginPage from "./pages/LoginPage";
import RegistrationPage from "./pages/RegistrationPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import EmailVerificationPage from "./pages/EmailVerificationPage";
import EmailNotVerifiedPage from "./pages/EmailNotVerifiedPage";
import MarketplacePage from "./pages/MarketplacePage";
import VaultPage from "./pages/VaultPage";
import SharedDocumentPage from "./pages/SharedDocumentPage";
import AddStatePage from "./pages/CreditTracker/AddStatePage";
import CmeStatePage from "./pages/CreditTracker/CmeStatePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import ClinicalUpdatesPage from "./pages/ClinicalUpdatesPage";
import ClinicalUpdateDetailPage from "./pages/ClinicalUpdateDetailPage";
import AdminPage from "./pages/AdminPage";
import RegisteredUsersPage from "./pages/RegisteredUsersPage";
import AdminRoute from "./components/AdminRoute";
import HelpWidget from "./components/HelpWidget";
import SubscribePage from "./pages/SubscribePage";
import SubscribeSuccessPage from "./pages/SubscribeSuccessPage";
import OnboardingRoute from "./components/OnboardingRoute";
import UnsubscribePage from "./pages/UnsubscribePage";

function App() {
    return (
        <AuthProvider>
        <BrowserRouter>
            <HelpWidget />
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/login" element={ <LoginPage/>} />
                <Route path="/register" element={<RegistrationPage/>} />
                <Route path="/reset-password" element={<ResetPasswordPage/>} />
                <Route path="/unsubscribe" element={<UnsubscribePage />} />
                <Route path="/verify-email" element={<EmailVerificationPage/>} />
                <Route path="/verify-email-change" element={<EmailChangeVerificationPage/>} />
                <Route path="/email-not-verified" element={<EmailNotVerifiedPage/>} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms-of-use" element={<TermsOfUsePage />} />

                <Route path="/profile" element={
                    <ProtectedRoute><ProfilePage /></ProtectedRoute>
                } />
                <Route path="/account" element={
                    <ProtectedRoute><AccountSettingsPage /></ProtectedRoute>
                } />
                <Route path="/dashboard" element={
                    <ProtectedRoute><OnboardingRoute><DashboardPage /></OnboardingRoute></ProtectedRoute>
                } />
                <Route path="/subscribe" element={
                    <ProtectedRoute><SubscribePage /></ProtectedRoute>
                } />
                <Route path="/subscribe/success" element={
                    <ProtectedRoute><SubscribeSuccessPage /></ProtectedRoute>
                } />
                <Route path="/purchases" element={
                    <ProtectedRoute><OnboardingRoute><FundTracker /></OnboardingRoute></ProtectedRoute>
                } />
                <Route path="/marketplace" element={
                    <ProtectedRoute><OnboardingRoute><MarketplacePage /></OnboardingRoute></ProtectedRoute>
                } />

                <Route path="/vault" element={
                    <ProtectedRoute><OnboardingRoute><VaultPage /></OnboardingRoute></ProtectedRoute>
                } />
                <Route path="/vault/shared/:token" element={<SharedDocumentPage />} />

                <Route path="/clinical-updates" element={
                    <ProtectedRoute><OnboardingRoute><ClinicalUpdatesPage /></OnboardingRoute></ProtectedRoute>
                } />
                <Route path="/clinical-updates/:slug" element={
                    <ProtectedRoute><OnboardingRoute><ClinicalUpdateDetailPage /></OnboardingRoute></ProtectedRoute>
                } />

                <Route
                    path="/creditTracker"
                    element={
                        <ProtectedRoute>
                            <OnboardingRoute><AddStatePage /></OnboardingRoute>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/creditTracker/state/:stateSlug"
                    element={
                        <ProtectedRoute>
                            <OnboardingRoute><CmeStatePage /></OnboardingRoute>
                        </ProtectedRoute>
                    }
                />

                <Route path="/admin" element={
                    <ProtectedRoute>
                        <AdminRoute><AdminPage /></AdminRoute>
                    </ProtectedRoute>
                } />
                <Route path="/admin/users" element={
                    <ProtectedRoute>
                        <AdminRoute><RegisteredUsersPage /></AdminRoute>
                    </ProtectedRoute>
                } />
            </Routes>
        </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
